<script>
import TemplatesPicker from './TemplatesPicker.vue';
import WhatsAppTemplateReply from './WhatsAppTemplateReply.vue';
import DvWhatsappTemplates from './DvWhatsappTemplates.vue';

// DV: account 1 gets the redesigned picker; other accounts (Vietved) keep Chatwoot's.
const DV_ACCOUNT_ID = 1;

export default {
  components: {
    TemplatesPicker,
    WhatsAppTemplateReply,
    DvWhatsappTemplates,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inboxId: {
      type: Number,
      default: undefined,
    },
    sendRenderedContent: {
      type: Boolean,
      default: false,
    },
    requestContactInfoOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onSend', 'cancel', 'update:show'],
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  computed: {
    isDvPicker() {
      return (
        Number(this.$store.getters.getCurrentAccountId) === DV_ACCOUNT_ID &&
        !this.requestContactInfoOnly
      );
    },
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    modalHeaderContent() {
      return this.selectedWaTemplate
        ? this.$t('WHATSAPP_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
            templateName: this.selectedWaTemplate.name,
          })
        : this.$t('WHATSAPP_TEMPLATES.MODAL.SUBTITLE');
    },
  },
  watch: {
    show(value) {
      if (!value) this.selectedWaTemplate = null;
    },
    requestContactInfoOnly() {
      this.selectedWaTemplate = null;
    },
  },
  methods: {
    pickTemplate(template) {
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('onSend', message);
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <woot-modal
    v-if="isDvPicker"
    v-model:show="localShow"
    :on-close="onClose"
    :show-close-button="false"
    size="modal-big dv-wa-modal"
  >
    <DvWhatsappTemplates
      v-if="localShow"
      :inbox-id="inboxId"
      :send-rendered-content="sendRenderedContent"
      @on-send="onSendMessage"
      @cancel="onClose"
    />
  </woot-modal>
  <woot-modal
    v-else
    v-model:show="localShow"
    :on-close="onClose"
    size="modal-big"
  >
    <woot-modal-header
      :header-title="$t('WHATSAPP_TEMPLATES.MODAL.TITLE')"
      :header-content="modalHeaderContent"
    />
    <div class="row modal-content">
      <TemplatesPicker
        v-if="!selectedWaTemplate"
        :inbox-id="inboxId"
        :request-contact-info-only="requestContactInfoOnly"
        @on-select="pickTemplate"
      />
      <WhatsAppTemplateReply
        v-else
        :template="selectedWaTemplate"
        :send-rendered-content="sendRenderedContent"
        @reset-template="onResetTemplate"
        @send-message="onSendMessage"
      />
    </div>
  </woot-modal>
</template>

<style scoped>
.modal-content {
  padding: 1.5625rem 2rem;
}
</style>

<style>
/* DV: wider, borderless shell for the redesigned picker (account 1). */
.dv-wa-modal.modal-container {
  width: min(64rem, calc(100vw - 2rem)) !important;
  max-width: calc(100vw - 2rem) !important;
  padding: 0 !important;
  overflow: hidden !important;
  background: rgb(var(--solid-1, 255 255 255));
}
</style>
